function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.52834 23.4083C6.04834 23.9283 6.88834 23.9283 7.40834 23.4083L11.0083 19.8083L9.12834 17.9283L5.52834 21.5283C5.00834 22.0483 5.00834 22.9016 5.52834 23.4083ZM21.1283 11.4216V14.4749H13.675L7.40834 8.19493C6.88834 7.67493 6.04834 7.67493 5.52834 8.19493C5.00834 8.71493 5.00834 9.55493 5.52834 10.0749L12.595 17.1416H21.1283V20.1949C21.1283 20.7949 21.8483 21.0883 22.2617 20.6616L26.6483 16.2749C26.915 16.0083 26.915 15.5949 26.6483 15.3283L22.2617 10.9416C21.8483 10.5283 21.1283 10.8216 21.1283 11.4216Z",
  fill: "white"
});

const SvgIcMenuConnections = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMenuConnections, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-menu-connections.d0d4608d.svg";
export { ForwardRef as ReactComponent };